import {
    GET_SIZE_ERROR, GET_SIZE_REQUEST, GET_SIZE_SUCCESS,
    ADD_SIZE_ERROR, ADD_SIZE_REQUEST, ADD_SIZE_SUCCESS,
    DELETE_SIZE_REQUEST, DELETE_SIZE_SUCCESS, DELETE_SIZE_ERROR,
    UPDATE_SIZE_ERROR, UPDATE_SIZE_REQUEST, UPDATE_SIZE_SUCCESS

} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_SIZE_REQUEST:
            return {
                loading: true,
            };
        case GET_SIZE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_SIZE_ERROR:
            return {
                ...state,
                loading: false
            };
        case ADD_SIZE_REQUEST:
            return {
                loading: true,
            };
        case ADD_SIZE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case ADD_SIZE_ERROR:
            return {
                ...state,
                loading: false
            };
        case DELETE_SIZE_REQUEST:
            return {
                loading: true,
            };
        case DELETE_SIZE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case DELETE_SIZE_ERROR:
            return {
                ...state,
                loading: false
            };
        case UPDATE_SIZE_REQUEST:
            return {
                loading: true,
            };
        case UPDATE_SIZE_SUCCESS:
            return {
                ...state,
                loading: false,
                payload: [payload],
            };
        case UPDATE_SIZE_ERROR:
            return {
                ...state,
                loading: false
            };

        default:
            return state;
    }
}